import { setFavorite } from '../../../shared/actions/newbuilding';
import { fetchAddFavorite, IAddFavoriteRequest } from '../../../shared/repositories/favorites/v1/add-favorite';
import { IFavoriteActionTypes } from '../../../shared/types/analytics/favorite';
import { TThunkAction } from '../../../shared/types/redux/thunk';
import { trackAddToFavorites } from './tracking';

export function addFavorite(
  gaLabel: string,
  parameters: IAddFavoriteRequest,
  eventActions?: IFavoriteActionTypes,
): TThunkAction {
  return async (dispatch, getState, { httpApi, logger }) => {
    dispatch(setFavorite(true));
    const newbuildingId = parameters.entityId;

    trackAddToFavorites(gaLabel, newbuildingId, eventActions && eventActions.add);

    try {
      await fetchAddFavorite({ httpApi, parameters });
    } catch (error) {
      logger.error(error, {
        newbuildingId,
        domain: 'addFavorite',
      });

      dispatch(setFavorite(false));
    }
  };
}
